import Header from './Header'
import Footer from './Footer'

export { Header, Footer }


// WEBPACK FOOTER //
// ./src/layout/index.js